/// <amd-module name="Test/Analytics/TestAnalyticInsightsReportView/Actions/TestInsightsReportViewActionsCreator" />
import { TestInsightsReportViewActions } from "Test/Analytics/TestAnalyticInsightsReportView/Actions/TestInsightsReportViewActions";
import { ITestResultTreeData } from "Test/common-util/Contracts/ViewContracts";

export class TestInsightsReportViewActionsCreator {
    constructor(private _actions: TestInsightsReportViewActions) {}

    public setTestResultTreeData(item: ITestResultTreeData): void {
        this._actions.setTestResultTreeData.invoke(item);
    }

    public closeDetailsPanel(): void {
        this._actions.closeDetailsPanel.invoke(undefined);
    }
}
